// src/i18n/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // 1️⃣ Load translation JSONs lazily from /public/locales/{{lng}}/{{ns}}.json
  .use(Backend)
  // 2️⃣ Detect language automatically (query, storage, cookie, browser)
  .use(LanguageDetector)
  // 3️⃣ Connect with React
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',                // default if nothing detected
    supportedLngs: ['en', 'es', 'fr','hi', 'mr'], // all supported languages
    ns: ['common', 'home', 'booking', 'about'], // namespaces (add as you grow)
    defaultNS: 'common',
    load: 'languageOnly',             // treat es-ES → es, hi-IN → hi
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json'
    },
    detection: {
      // Detection priority order:
      order: ['querystring', 'localStorage', 'cookie', 'navigator'],
      // Where to store user preference once selected:
      caches: ['localStorage', 'cookie'],
      // Optional cookie name customization:
      cookieMinutes: 10080 // 7 days
    },
    interpolation: { escapeValue: false },
    react: { useSuspense: true }
  });

export default i18n;
